import React from 'react';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import App from './main/App';

const root = document.getElementById('app');

ReactDOM.render(
  <React.StrictMode>
    {/* @ts-ignore */}
    <HistoryRouter basename={process.env.REACT_APP_SUBPATH} history={createBrowserHistory({ window })}>
      <App />
    </HistoryRouter>
  </React.StrictMode>,
  root,
);
